import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { KioskBranding } from '@/api/endpoints/kiosk-branding'
import { kioskBrandingApi } from '@/api/endpoints/kiosk-branding'

export function useRestaurantKioskBranding(restaurantId: number) {
  return useQuery({
    queryKey: ['restaurantKioskBranding', restaurantId],
    queryFn: () => kioskBrandingApi.get(restaurantId),
    staleTime: 0,
  })
}

export function useSaveRestaurantKioskBranding(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: KioskBranding) =>
      kioskBrandingApi.save(restaurantId, body),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: ['restaurantKioskBranding', restaurantId],
      })
    },
  })
}
